import { render } from "./DocumentsTab.vue?vue&type=template&id=1427f6a8&scoped=true"
import script from "./DocumentsTab.vue?vue&type=script&lang=js"
export * from "./DocumentsTab.vue?vue&type=script&lang=js"

import "./DocumentsTab.vue?vue&type=style&index=0&id=1427f6a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1427f6a8"]])

export default __exports__